var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "form-control-structure-browser-wrapper" },
    [
      _setup.showEditable
        ? _c(
            "div",
            { staticClass: "d-flex align-items-center" },
            [
              _c(_setup.FormControlTypeCheckbox, {
                attrs: {
                  "current-data": _vm.currentData,
                  field: _vm.field,
                  "form-id": _vm.formId,
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "ms-3" }, [
                _c(
                  "label",
                  { staticClass: "d-inline-flex align-items-center gap-1" },
                  [
                    _c("small", [_vm._v("Make editable:")]),
                    _vm._v(" "),
                    _c("input", {
                      attrs: { type: "checkbox" },
                      domProps: { checked: _setup.isEditable },
                      on: { change: _setup.toggleEditable },
                    }),
                  ]
                ),
              ]),
            ],
            1
          )
        : _c(_setup.FormControlTypeCheckbox, {
            attrs: {
              "current-data": _vm.currentData,
              field: _vm.field,
              "form-id": _vm.formId,
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }